import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-select',
  templateUrl: './search-select.component.html',
  styleUrl: './search-select.component.scss'
})
export class SearchSelectComponent {
  @Input() options: {id: string, label: string}[] = [];
  @Input() selectedOptions: {id: string, label: string}[] = [];
  @Input() isMultiple: boolean = false;
  @Output() emitSelectedOptions = new EventEmitter<{id: string, label: string}[]>();
  @Output() emitInputValue = new EventEmitter<string>();  
  public isFocused = false;

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
  }


  onOptionClick(option: {id: string, label: string}) {
    if(this.isMultiple) {
      if(this.selectedOptions.find(o => o.id === option.id)) {
        this.selectedOptions = this.selectedOptions.filter(o => o.id !== option.id);
      } else {
        this.selectedOptions.push(option);
      }
    } else {
      this.selectedOptions = [option];
    }
    this.emitSelectedOptions.emit(this.selectedOptions);
  }

  onDeselect(option: {id: string, label: string}) {
    this.selectedOptions = this.selectedOptions.filter(o => o.id !== option.id);
    this.emitSelectedOptions.emit(this.selectedOptions);
  }

  onKeyUp(event: KeyboardEvent) {
    this.emitInputValue.emit((event.target as HTMLInputElement).value);
  }
}
